import React from 'react';
import { IconLink } from '@bynder/icons';
import { SyntheticEvent } from 'react-draft-wysiwyg';
import { notify } from '@bynder/design-system';
import { copyShareUrlToClipboard } from '../../constants/widgets';
import { LinkCopiedToClipboardNotification } from '../../types/notifications';
import { StyledButton } from '../notifications/CardShareLink';

interface GuideShareLinkButtonProps {
  buttonText: string;
  guideId: string;
  pageId?: string;
  color?: string;
}

export const GuideShareLinkButton: React.FC<GuideShareLinkButtonProps> = ({
  buttonText,
  guideId,
  pageId,
  color,
}) => {
  const handleClick = (e: SyntheticEvent) => {
    e.preventDefault();
    copyShareUrlToClipboard(guideId, pageId)
      .then(() => notify(LinkCopiedToClipboardNotification))
      .catch(e => {
        throw new Error(e);
      });
  };

  return (
    <StyledButton
      aria-label="copyLink"
      variant="clean"
      onClick={handleClick}
      icon={<IconLink />}
      data-testid="shareLinkButton"
      $color={color ?? ''}
    >
      {buttonText}
    </StyledButton>
  );
};
